import type { ReactElement } from 'react';
import { PageHeader } from '../components/system/index.js';
import { BlockedState } from '../components/feedback/index.js';

/**
 * A route whose backend is one of the 58 blocked endpoints. It states the
 * position plainly and offers NO affordance — a disabled button would imply
 * the feature exists and is merely switched off.
 */
export function BlockedPage({
  title,
  capability,
  reason,
}: {
  title: string;
  capability: string;
  reason: string;
}): ReactElement {
  return (
    <div className="page page--task">
      {/*
        No eyebrow, no context line, no `Primary`. A route whose capability does
        not exist has nothing to do and nothing to be in the middle of, and
        dressing it with the furniture of a working screen would imply it is
        one that happens to be empty today.
      */}
      <PageHeader title={title} />
      <BlockedState capability={capability} reason={reason} />
    </div>
  );
}
